import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isCombosEnabled } from 'utils/featureFlags';

type Props = { children: ReactNode };

/** Blocks /combos when the combos feature flag is off. */
export const CombosRouteGate = ({ children }: Props) => {
	if (!isCombosEnabled()) {
		return <Navigate to="/" replace />;
	}

	return <>{children}</>;
};
